import useTermOrdersBanner from "./useTermOrdersBanners";
import AddressBanner from "./AddressBanner";
import ReturnBanner from "./ReturnBanner";
import { UserPreferenceKey } from "common/api/decimal/methods/user";

export default function TermOrdersBannerManager() {
  const {
    shippingReturns,
    campusReturns,
    verifyAddress,
    preferredShippingAddress,
  } = useTermOrdersBanner();

  return (
    <>
      {verifyAddress && (
        <AddressBanner
          preferredAddress={preferredShippingAddress}
          bannerSeenPreferenceKey={
            UserPreferenceKey.MyCoursesAddressConfirmationExpiredOn
          }
          key="address"
        />
      )}
      {shippingReturns.length > 0 && (
        <ReturnBanner items={shippingReturns} type="Shipping" key="shipping" />
      )}
      {campusReturns.length > 0 && (
        <ReturnBanner items={campusReturns} type="Campus" key="campus" />
      )}
    </>
  );
}
